import { CSSProperties } from 'react'

import { SxProps } from '@mui/material'

import theme from '../../../../shared/styles/themes/default.theme'

const styles = {
  container: {
    display: 'flex',
    flexDirection: 'column',
    padding: theme.spacing(3),
    marginBottom: theme.spacing(2),
    borderRadius: theme.shape.borderRadius / 4,
    backgroundColor: theme.palette.background.default,
    boxShadow: theme.shadows[3],
    [theme.breakpoints.down('md')]: {
      display: 'none'
    }
  } as SxProps,

  accordionContainer: {
    position: 'fixed',
    bottom: 0,
    left: 0,
    right: 0,
    zIndex: 1000,
    display: 'none',
    boxShadow: theme.shadows[3],
    [theme.breakpoints.down('md')]: {
      display: 'flex'
    }
  } as SxProps,

  cardTop: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'flex-start',
    gap: theme.spacing(2)
  } as SxProps,

  title: {
    color: theme.palette.grey[800],
    fontWeight: theme.typography.fontWeightMedium,
    textAlign: 'left'
  } as SxProps,

  divider: {
    margin: theme.spacing(2, 0)
  } as SxProps,

  sectionContent: {
    paddingRight: theme.spacing(2)
  } as SxProps,

  section: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    textAlign: 'left',
    marginBottom: theme.spacing(2),
    flexWrap: 'wrap'
  } as SxProps,

  sectionTitle: {
    fontWeight: theme.typography.fontWeightBold
  } as SxProps,

  priceSummaryContainer: {
    display: 'flex',
    flexDirection: 'column',
    textAlign: 'left'
  } as SxProps,

  priceSummaryTitle: {
    fontWeight: theme.typography.fontWeightBold,
    marginBottom: theme.spacing(1)
  } as SxProps,

  row: (isLast: boolean) =>
    ({
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'space-between',
      alignItems: 'center',
      flexWrap: 'wrap',
      marginBottom: isLast ? 0 : theme.spacing(1)
    }) as SxProps,

  timeSpan: {
    fontWeight: theme.typography.fontWeightBold,
    color: theme.palette.grey[800],
    marginBottom: theme.spacing(0)
  } as CSSProperties,

  rowContentTitle: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'flex-start',
    gap: theme.spacing(1),
    paddingRight: theme.spacing(2)
  } as SxProps,

  subtotalTitleText: (isBold?: boolean, isSpecial?: boolean) =>
    ({
      textAlign: 'left',
      fontWeight: isBold ? theme.typography.fontWeightBold : theme.typography.fontWeightMedium,
      color: isSpecial ? theme.palette.primary.main : theme.palette.grey[500]
    }) as SxProps,

  subtotalValue: (isBold?: boolean, isSpecial?: boolean) =>
    ({
      color: isSpecial ? theme.palette.primary.main : theme.palette.grey[500],
      textAlign: 'left',
      fontWeight: isBold ? theme.typography.fontWeightBold : theme.typography.fontWeightMedium
    }) as SxProps,

  infoIcon: {
    width: '16px',
    height: '16px'
  } as SxProps,

  segmentValueText: {
    color: theme.palette.grey[500],
    textAlign: 'left'
  } as SxProps,

  subTextBold: {
    color: theme.palette.grey[500],
    marginBottom: theme.spacing(1)
  } as SxProps,

  gap: {
    marginBottom: theme.spacing(1)
  } as SxProps,

  logo: {
    width: '40px',
    height: '40px',
    marginTop: theme.spacing(1)
  },

  amountToPayContainer: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    flexWrap: 'wrap'
  } as SxProps,

  amountToPayTitle: {
    textAlign: 'left',
    fontWeight: theme.typography.fontWeightBold,
    paddingRight: theme.spacing(2)
  } as SxProps,

  amount: {
    color: theme.palette.primary.main,
    fontWeight: theme.typography.fontWeightBold
  } as SxProps,

  viewOverviewButton: {
    padding: 0,
    fontWeight: theme.typography.fontWeightBold,
    textTransform: 'none',
    textAlign: 'left'
  } as SxProps,

  viewOverviewButtonIcon: {
    fontSize: '16px'
  } as SxProps,

  accordionMainContent: {
    display: 'flex',
    width: '100%',
    flexDirection: 'column',
    alignItems: 'flex-start',
    padding: theme.spacing(2)
  } as SxProps,

  accordionBody: {
    padding: theme.spacing(2)
  } as SxProps
}

export default styles
